import { WebsiteCommunicationStatus } from '@amzn/brand-registry-communication-service-type-script-client';

const statusToRank: Record<WebsiteCommunicationStatus, number> = {
  SENT: 0,
  DISPLAYED: 1,
  ENGAGED: 2,
};

export const localStorageKey = 'br-spotlight-statuses';

/**
 * Store in local storage the most up-to-date status of a communication.
 */
export const setLocalStorageStatus = (communicationId: string, status: WebsiteCommunicationStatus) => {
  const previousStore = localStorage.getItem(localStorageKey);

  if (!previousStore) {
    const statuses = JSON.stringify({ [communicationId]: status });
    localStorage.setItem(localStorageKey, statuses);
    return;
  }
  
  const previousStoreObject = JSON.parse(previousStore);

  const previousStatus = previousStoreObject[communicationId];

  // Only overwrite the previous status if it is of higher rank or does not currently exist in local storage
  if (!previousStatus || statusToRank[status] > statusToRank[previousStatus as WebsiteCommunicationStatus]) {
    const newStore: Record<string, WebsiteCommunicationStatus> = {
      ...previousStoreObject,
      [communicationId]: status,
    };

    localStorage.setItem(localStorageKey, JSON.stringify(newStore));
  }
};

/**
 * Retrieve the most up-to-date status of a communication. We check local storage first in case there was a previous
 * interaction that happened too quickly for us to have stored and retrieved between new page loads.
 */
export const getCommunicationStatus = (
  communicationId: string,
  contextStatus: WebsiteCommunicationStatus
): WebsiteCommunicationStatus => {
  const commStatusStore = localStorage.getItem(localStorageKey);
  if (commStatusStore) {
    const status = JSON.parse(commStatusStore)[communicationId] as WebsiteCommunicationStatus;

    // If the status stored in local storage has a higher rank than the existing one, send that one back
    return (status && statusToRank[status] > statusToRank[contextStatus]) ? status : contextStatus;
  }

  return contextStatus;
};
